import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

interface CommonInterface {
  invite: string;
}

export const initialCommonState: BaseStoreInterface<CommonInterface> = {
  ...BaseStoreStructure,
  data: {
    invite: '',
  },
};
